import React from "react";
import { connect } from "react-redux";
import { IAppState } from "../../types/state";
import { myDispatcher, updateInput } from "../../store/actionGenerators";

interface InputBoxProps {
    input: string
}

interface InputBoxState {
    input: string
}

class InputBox extends React.Component<InputBoxProps, InputBoxState> {
    constructor(props: InputBoxProps) {
        super(props);
        this.state = { input: this.props.input };
    }

    render() {
        return <div className='InputBox'>
            <textarea onChange={evt => this.updateInputValue(evt)} value={this.state.input}></textarea>
        </div>;
    }

    updateInputValue(evt: React.ChangeEvent<HTMLTextAreaElement>) {
        let newInput = evt.target.value;
        this.setState({ input: newInput });
        myDispatcher(updateInput(newInput));
    }
}

function mapStateToProps(state: IAppState): InputBoxProps {
    return { input: state.input };
}

export default connect(mapStateToProps)(InputBox);
